<template>
  <section className="cont__contact">
    <p>Let’s create something new</p>
    <h3>LET`S Get IN<em>TOUCH</em></h3>
    <router-link to="/contact">contact me</router-link>
  </section>
</template>
<style lang="scss"></style>
